import { IFinSobState } from 'partner360/features/finSob/models/state'

export const initialState: IFinSobState = {
  isApplicableSwitcherLoading: false,
  isPlanningSettingsLoading: false,
  isPartnerFlagsLoading: false,
  isPlanningDataLoading: false,
  isPlanningFactorsLoading: false,
  isCategoryPlanningApplyingChangesLoading: false,
  isCategoryPlanningDataLoading: false,
}
